module.exports = __webpack_public_path__ + "static/img/honor-button.f8d713a4.png";